import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name : 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
  public transform(value, key: string, term: string) {
    return value.filter((item) => {
      if (item.hasOwnProperty(key)) {
        if (term) {
          return item[key].toLowerCase().indexOf(term.toLowerCase())+1;
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  }
}